export const iconFontAwesomePoliticalLandmarkFlag = (
	<i className="fa-solid fa-landmark-flag"></i>
);
